import { a as R, g as U, h as z, i as D, b as E, c as S, d as T, j as q, o as A, s as B, k as G, l as J } from "../../../floating-ui.react--Sr3isS-.js";
import { useState as K, useImperativeHandle as L, useMemo as N } from "react";
const W = (l) => {
  const {
    defaultOpen: d = !1,
    delay: f,
    interaction: t,
    matchTriggerWidth: u = !1,
    maxHeight: a,
    offset: m,
    onOpenChange: g,
    open: h,
    placement: O,
    popoverRef: y,
    role: x,
    strategy: w,
    viewportMargin: r
  } = l, [k, C] = K(d), M = h ?? k, e = g ?? C;
  L(y, () => ({
    open: () => e(!0),
    close: () => e(!1)
  }));
  const c = R({
    middleware: [
      A(m),
      B({ padding: r }),
      G({ padding: r }),
      J({
        padding: r,
        apply({
          rects: F,
          elements: H,
          availableHeight: o,
          availableWidth: p
        }) {
          const n = {};
          if (u && (n.width = `${F.reference.width}px`), typeof p == "number" && p > 0 && (n.maxWidth = `${p}px`), a !== void 0 && typeof o == "number" && o > 0) {
            const I = typeof a == "number" ? Math.min(o, a) : o;
            n.maxHeight = `${I}px`;
          }
          Object.assign(H.floating.style, n);
        }
      })
    ],
    open: M,
    onOpenChange: e,
    placement: O,
    strategy: w,
    whileElementsMounted: q
  }), { context: s } = c, b = U(s, { enabled: t?.click ?? !1 }), v = z(s, {
    enabled: t?.hover ?? !1,
    delay: { open: f }
  }), P = D(s, { enabled: t?.focus ?? !1 }), $ = E(s), j = S(s, { role: x }), i = T([b, $, v, P, j]);
  return N(
    () => ({
      setOpen: e,
      ...c,
      ...i
    }),
    [e, i, c]
  );
};
export {
  W as default
};
